import {afterRenderEffect, Injectable} from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  private gtmScriptLoaded = false;

  constructor() {
    afterRenderEffect(() => {
      const loadGtmOnInteraction = () => {
        if (this.gtmScriptLoaded) {
          return;
        }
        this.gtmScriptLoaded = true;

        if (window.dataLayer) {
          return;
        }
        const gtmId = 'GTM-MQGR84P7'; // Replace with your GTM ID
        const script = document.createElement('script');
        script.defer = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });

        const noscript = document.createElement('noscript');
        const iframe: any = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = 0;
        iframe.width = 0;
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);

        script.onerror = () => {
          console.error('Failed to load GTM script.');
        };

        window.removeEventListener('scroll', loadGtmOnInteraction);
        window.removeEventListener('click', loadGtmOnInteraction);
      };

      window.addEventListener('scroll', loadGtmOnInteraction, { once: true });
      window.addEventListener('click', loadGtmOnInteraction, { once: true });
    });
  }
  initializeGtm() {}
}
